$(function(){
	var searchEl = $('.top__search input');

	searchEl.on('change', function(){
		let query = this.value;

		if(query) window.location.href = '/search/' + query + '/';
	});
});